import { useEffect, useState } from "react";
import { useSpring, animated } from "react-spring";
import styles from "./Spark1.module.css";
import coine from "../../images/coine.png";

const Spark = ({ x, y }: { x: number; y: number }) => {
  const props = useSpring({
    to: [
      { 
        opacity: 1, 
        x: x + Math.cos(Math.random() * Math.PI * 2) * 50,
        y: y - Math.random() * 150, 
        scale: 0.3 
      },
      { 
        opacity: 0, 
        x: x + Math.cos(Math.random() * Math.PI * 2) * 100,
        y: y - 100, 
        scale: 0.1 
      }
    ],
    from: { opacity: 0, x, y, scale: 0.1 },
    config: { tension: 150, friction: 20 },
  });

  return (
    <animated.div style={props} className={styles.spark}>
      <img src={coine} alt="spark" />
    </animated.div>
  );
};

export default function Spark2() {
  const [sparks, setSparks] = useState<{ id: number; x: number; y: number }[]>([]);

  useEffect(() => {
    const interval = setInterval(() => {
      setSparks((prev) => [
        ...prev,
        { id: Date.now(), x: Math.random() * 200, y: Math.random() * 50 + 100 },
      ]);
      setTimeout(() => {
        setSparks((prev) => prev.slice(1));
      }, 500);
    }, 50);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className={styles.container}>
      {sparks.map((spark) => (
        <Spark key={spark.id} x={spark.x} y={spark.y} />
      ))}
    </div>
  );
}
